export var Paths;

(function (Paths) {
  Paths["Create"] = "/me/playlists";
  Paths["Update"] = "/me/playlists/:playlistUid";
  Paths["Remove"] = "/me/playlists/:playlistUid";
  Paths["AddVideo"] = "/me/playlists/:playlistUid/videos";
  Paths["RemoveVideo"] = "/me/playlists/:playlistUid/videos/:videoId";
  Paths["OrderVideos"] = "/me/playlists/:playlistUid/videos/order";
})(Paths || (Paths = {}));